import React from 'react'
//=======Material UI
import Grid from '@material-ui/core/Grid'
import useTheme from '@material-ui/core/styles/useTheme'
import useMediaQuery from '@material-ui/core/useMediaQuery'

import useCloseProject from './useCloseProject'
import Researcher from './researcher/researcher'
import Officer from './officer/officer'
import useCheckPermission from '../../../../../utilities/checkPermission'
import Dialog from '../../../../../control/dialog/dialog'
import Button from '../../../../../control/button/button'
import useTranslate from '../../../../../i18n/useTranslate'
import constSubmittedStep from '../../../../../constants/submittedStep'

import ButtonSubmittedWithdraw from '../../page/_sharedPageComponent/buttonSubmittedWithdraw/buttonSubmittedWithdraw'

type CloseProjectViewType = ReturnType<typeof useCloseProject> & Omit<CloseProjectType, 'projectMode'>
const CloseProjectView: React.FC<CloseProjectViewType> = (props) => {
    const {
        projectMode,
        isViewMode,
        configDialog,
        projectData,
        onRefDialog,
        onCallbackSaveComplete,
        onClickBackToSearch,
    } = props
    const checkPermission = useCheckPermission()
    const isUserResearcher = checkPermission.isUserResearcher()
    const translate = useTranslate()
    const theme = useTheme()
    const isMobileView = useMediaQuery(theme.breakpoints.down('xs'))
    const isBtnClose =
        checkPermission.isUserChairman() && projectData?.stepID === constSubmittedStep.synthesis ? false : isViewMode

    const canUpdateDocument = checkPermission.checkCanUpdateDocument(projectData)

    const renderUserRoleComponent = () => {
        if (isUserResearcher) {
            return <Researcher projectMode={projectMode} callbackSaveComplete={onCallbackSaveComplete} />
        } else {
            return <Officer callbackSaveComplete={onCallbackSaveComplete} />
        }
    }
    React.useEffect(() => {
        console.log('CloseProjectView')
    }, [])
    return (
        <Grid container spacing={2}>
            <Grid container item>
                {renderUserRoleComponent()}
            </Grid>
            {isBtnClose && !canUpdateDocument ? (
                <Grid container item justify="space-between" spacing={2}>
                    <Grid item xs={12} sm={'auto'}>
                        <ButtonSubmittedWithdraw gridProps={{ xs: false }} fullWidth={isMobileView ? true : false} />
                    </Grid>
                    <Grid item xs={12} sm={'auto'}>
                        <Button color="primary" onClick={onClickBackToSearch} fullWidth={isMobileView ? true : false}>
                            {translate.get('BUTTON.CLOSE')}
                        </Button>
                    </Grid>
                </Grid>
            ) : null}
            <Dialog onRef={onRefDialog} {...configDialog} />
        </Grid>
    )
}

export type CloseProjectType = {
    projectMode: 'CREATE' | 'EDIT'
}
const CloseProject: React.FC<CloseProjectType> = (props) => {
    const closeProjectModel = useCloseProject(props)

    return <CloseProjectView {...closeProjectModel} />
}
export default CloseProject
